import HttpData from "@/http/data/http-data";

export interface IAccessControlDoorUnlockData {
    opened: boolean;
}

export default class AccessControlDoorUnlockData extends HttpData {
    public opened: boolean;

    constructor(data: IAccessControlDoorUnlockData) {
        super();

        this.opened = data.opened;
    }
}
